import React, { memo, useCallback } from 'react';

import downloadIos from 'assets/image/download-ios.png';

import Analytics from 'app/lib/Analytics/Analytics';
import styles from './DownloadIOS.module.css';

interface IDownloadIOS {
}

const DownloadIOS: React.FC<IDownloadIOS> = memo((props) => {
  const handleDownloadByLink = useCallback(() => {
    Analytics.track().tappedGetCardSnacks();
  }, []);

  const handleDownloadIos = useCallback(() => {
    Analytics.track().tappedCreateYourOwn();
  }, []);

  return (
    <div className={styles.steps}>
      <div className={styles.header}>
        Want to create
        <br />
        your own cards?
      </div>
      <div className={styles.download}>
        <a
          className={styles.downloadTitle}
          onClick={handleDownloadByLink}
          href="https://cardsnacks.go.link/lBq3x"
        >
          <span>Get the CardSnacks app</span>
        </a>
        <div className={styles.downloadLink}>
          <a
            className={styles.buttonAppStore}
            onClick={handleDownloadIos}
            href="https://cardsnacks.go.link/lBq3x"
          >
            <img alt="" src={downloadIos} />
          </a>
        </div>
      </div>
    </div>
  );
});

export default DownloadIOS;
